<template>
  <el-dialog
    title="提示"
    width="30%"
    :before-close="handleClose"
    :visible.sync="tipParmas.tipsVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="tipParmas.showClose"
  >
    <div class="content" v-html=" tipParmas.tipsContent" />
    <span slot="footer" class="dialog-footer">
      <el-button v-if="tipParmas.cancelText" class="cancel" @click="handleClose">{{ tipParmas.cancelText }}</el-button>
      <el-button v-if="tipParmas.confirmText" :disabled="tipParmas.disabled" :loading="tipParmas.disabled" class="sure" type="primary" @click="confirm">{{ tipParmas.confirmText }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    tipParmas: {
      type: Object,
      default() {
        return {
        }
      }
    }
  },
  data() {
    return {
      // btnDisabled: false
    }
  },
  methods: {
    handleClose() {
      this.$emit('cancel')
    },
    confirm() {
      this.$emit('confirm')
    },
    btnChange(val) {
      this.btnDisabled = val;
    }
  }
}
</script>
  <style lang="scss" scoped>
.content{
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #606060;
    line-height: 22px;
}
  </style>

